import Vue from 'vue'
import messages from 'vee-validate/dist/locale/nl'
import VeeValidate, { Validator } from 'vee-validate'

Validator.addLocale(messages)

const recursiveComponents = function* (component) {
  yield component
  for (let i = 0; i < component.$children.length; i++) {
    const item = component.$children[i]
    yield * recursiveComponents(item)
  }
}

Vue.prototype.$validateAllComponents = function () {
  const allComponents = recursiveComponents(this)
  const validations = []
  while (true) {
    const component = allComponents.next().value
    if (!component) {
      break
    }

    if (component.$validator) {
      validations.push(component.$validator.validateAll())
    }
  }

  return Promise.all(validations).then(values => {
    const containsInvalid = values.filter(v => v === false).length > 0
    const isValid = !containsInvalid
    return isValid
  })
}

const config = {
  errorBagName: 'vErrors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'nl',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'blur',
  inject: true,
  validity: true,
  aria: true
}

Vue.use(VeeValidate, config)
